
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { FilterableMasterSelectableMixin } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { Profession } from "../../../../domain/user";

@Component({
})
export default class ProfessionSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: Profession[];

  @Prop({ default: null })
  defaultSelectedProfessionCode: string;

  @Watch("values")
  onValuesUpdated(newValue: Profession[], oldValue: Profession[]) {
    // 初回にデフォルト選択をセットする
    if (!oldValue && newValue) {
      if (!this.editingSource && this.defaultSelectedProfessionCode) {
        const found = newValue.find(p => !!p && p.id === this.defaultSelectedProfessionCode);
        if (found) {
          this.editingSource = found;
        }
      }
    }
  }

  created() {
    const repository = DomainRegistry.user.getProfessionRepository();
    repository.getAllEntities()
      .then(e => this.values = e)
      .catch(e => {
        this.$error(
          "職種情報取得失敗",
          "職種情報を取得できませんでした。",
          e,
        );
      });
  }
}
